import PropTypes from 'prop-types';
import React from 'react';
import { ArrowRightShort } from 'react-bootstrap-icons';

import GroupLink from '../group_link';
import Link from '../link';

const BtnIcon = ({
	children,
	className,
	iconSize = 'lg',
	label,
	labelBefore,
	labelSize = 'md',
	linkType = 'link',
	size,
	type,
	variant = 'light',
	...props
}) => {
	const variants = {
		blur: {
			icon: 'bg-blur',
			label: 'text-dark',
		},
		danger: { icon: 'bg-gray-100 text-danger btn-circle', label: 'text-dark' },
		dark: { icon: 'bg-dark text-white btn-circle', label: 'text-white o-80' },
		dark2: { icon: 'bg-dark text-white btn-circle', label: 'text-dark' },
		gray: { icon: 'btn-light bg-gray-300 btn-circle', label: 'text-dark' },
		light: { icon: 'btn-light btn-circle', label: 'text-dark' },
		light2: {
			icon: 'btn-light bg-gray-100 border-0 btn-circle',
			label: 'text-dark',
		},
		nav: {
			icon: 'btn-circle-transparent btn-circle-nav',
			label: 'text-dark',
		},
		outline: {
			icon: 'btn-circle-transparent border btn-circle',
			label: 'text-dark',
		},
		show_more: {
			icon: 'btn-light btn-circle',
			label: 'text-dark',
		},

		show_more_transparent: {
			icon: 'btn-circle-transparent btn-circle',
			label: 'text-dark',
		},
		transparent: {
			icon: 'btn-circle-transparent btn-circle',
			label: 'text-dark',
		},
		transparent_dark: {
			icon: 'btn-circle-transparent text-white btn-circle',
			label: 'text-white',
		},
	};

	const iconSizes = {
		lg: 'lg',
		md: 'md',
		sm: 'sm',
		xl: 'xl',
		xxl: 'xxl',
	};

	const sizes = {
		lg: 'lg',
		md: 'md',
		nav: 'nav',
		nav_user: 'nav-user',
		sm: 'sm',
		xl: 'xl',
		xxl: 'xxl',
	};

	const labelSizes = {
		lg: 'lg',
		md: 'base',
		nav_link: 'nav-link',
		sm: 'sm',
		xs: 'xs',
	};

	const linkTypes = {
		button: {
			Component: 'button',
		},
		div: {
			Component: 'div',
		},
		group_link: {
			Component: GroupLink,
		},
		link: {
			Component: Link,
		},
	};

	const LinkType = linkTypes[linkType]?.Component;

	return (
		<LinkType
			className={`${className} btn btn-link text-start px-0 btn-circle-container text-decoration-none ${
				type === 'column'
					? 'd-flex align-items-center flex-column'
					: 'd-flex align-items-center'
			}   `}
			{...props}
		>
			{labelBefore && (
				<div
					className={`ms-1 ${variants[variant].label}  ${labelSizes[labelSize]}`}
				>
					{labelBefore}
				</div>
			)}
			{!children ? (
				<div
					className={`btn  position-relative   ${variants[variant].icon} icon-container-${iconSizes[iconSize]} icon-${sizes[size]}`}
				>
					{children || <ArrowRightShort />}
				</div>
			) : (
				<div
					className={`btn  position-relative   ${variants[variant].icon} icon-container-${iconSizes[iconSize]} icon-${sizes[size]}`}
				>
					{children}
				</div>
			)}
			{label && (
				<div
					className={`ms-1 ${variants[variant].label}  ${
						labelSizes[labelSize]
					} ${type === 'column' && 'text-center mt-3 fw-600'}`}
				>
					{label}
				</div>
			)}
		</LinkType>
	);
};

BtnIcon.propTypes = {
	children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
	className: PropTypes.string,
	iconSize: PropTypes.string,
	label: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
	labelBefore: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
	labelSize: PropTypes.string,
	linkType: PropTypes.string,
	size: PropTypes.string,
	titleClassName: PropTypes.string,
	type: PropTypes.string,
	variant: PropTypes.string,
};

export default BtnIcon;
